import { XosImageStates, XosImageResult } from './models';
import { Nullable } from 'common';

export const GET_XOSIMAGE_STATES_SUCCESS = 'GET_XOSIMAGE_STATES_SUCCESS';
export const SET_LOADING = 'SET_LOADING';
export const RESET_RESULTS = 'RESET_RESULTS';
export const XOSIMAGE_RESULT_SUCCESS = 'XOSIMAGE_RESULT_SUCCESS';

export interface XosImageState {
  loading: boolean;
  xosImagesStates: Nullable<XosImageStates>;
  result: Nullable<XosImageResult>;
}

export interface SetResultLoadingType {
  type: typeof SET_LOADING;
  loading: boolean;
}

/* GET_STATES */

export interface GetStatesSuccessType {
  type: typeof GET_XOSIMAGE_STATES_SUCCESS;
  xosImageStates: XosImageStates;
}

/* GET_DRIVERS */

export interface SearchResultSuccessType {
  type: typeof XOSIMAGE_RESULT_SUCCESS;
  result: XosImageResult;
}

export interface ResetResultsType {
  type: typeof RESET_RESULTS;
}

export type XosImageTypes =
  | GetStatesSuccessType
  | SetResultLoadingType
  | SearchResultSuccessType
  | ResetResultsType;
